import Vue from "vue";
import VueRouter from "vue-router";

import routerRoutes from "./routes.js";
import store from "@/store";
Vue.use(VueRouter);
const router = new VueRouter({
  mode: process.env.NODE_ENV === 'chrome' ? '':"history",
  base: process.env.BASE_URL,
  routes: routerRoutes, //使用
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});
router.beforeEach(async (to, from, next) => {
  const isLogin = store.state.user.isLogin;
  const token = sessionStorage.getItem("MASS_WALLET_Token");
  if (to.meta.authorization) {
    // 需验证 登录态
    if (token && !isLogin) {
      try {
        await store.dispatch("user/walletLogin");
        next();
      } catch (e) {
        sessionStorage.removeItem("MASS_WALLET_Token");
        next({ name: "login" });
      }
    } else if (!token) {
      next({ name: "login" });
    } else {
      next();
    }
  // } 
  // else if (token) {
  //   //无需验证， 且已登录的
  //   next({ name: "home" });
  } else {
    next();
  }
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
export default router;
